import React, { useRef } from "react";
import { connect } from "react-redux";
import { ACTION_APPLY, ACTION_CLOSE, MDialog, MSelect } from "components/Shared";
import { UserUnderwriter } from "interfaces/Mueller.Business.Models";
import { addInternetUser } from "actions/underwriter";

interface UserUnderwriterAddDialogProps {
  underwriter: UserUnderwriter;
  onCancel: () => void;
  onConfirm: (underwriterId: number, internetUserId: number) => void;
  visible: boolean;
  //redux
  authorizedUnderwriters: UserUnderwriter[];
  internetUserId: number;
}

const UserUnderwriterAddDialog = (props: UserUnderwriterAddDialogProps) => {

  const underwriterId = useRef();

  const handleAddConfirmClick = () => {
    props.onConfirm(underwriterId.current, props.internetUserId);
  };

  const onChangeUnderwriterSelection = (input: { value: any; label: string; }) => {
    underwriterId.current = input.value;
  };

  const getAuthorizedUnderwritersDropDownOptions = () => {
    return props.authorizedUnderwriters.map(uw => ({ value: uw.id, label: uw.underwriterCode }))
  };

  return (
    <MDialog
      title="Add Underwriter"
      className="underwriter-mdialog"
      actions={[
        { code: ACTION_APPLY, onClick: () => handleAddConfirmClick() },
        {
          code: ACTION_CLOSE, onClick: () => {
            props.onCancel();
          }
        }]}
      children={[
        <MSelect
          key="underwriters-dropdown"
          isClearable={false}
          onChange={onChangeUnderwriterSelection}
          options={getAuthorizedUnderwritersDropDownOptions()}
        />
      ]}
      visible={props.visible}
    />
  );
};

const mapStateToProps = state => {
  return {
    userUnderwriters: state.user.userUnderwriters,
    authorizedUnderwriters: state.user.authorizedUnderwriters,
    internetUserId: state.user.internetUserId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addUnderwriterInternetUser(underwriterId, internetUserId) {
      dispatch(addInternetUser(underwriterId, internetUserId));
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserUnderwriterAddDialog);